// @i18n-ignore-file
import { IStatsigExperiment } from '@src/experiments/experiments.types'

export enum STATSIG_EXPERIMENTS {
  BANNER_A_CLP_A_V_A_EXPERIMENT = 'banner-a-clp-a-v-clp-a',
  MWEB_APP_BANNER = 'mweb-app-banner',
  EXPRESS_CHECKOUT_IN_CART = 'express-checkout-in-cart',
  SECOND_RETURNS_CHARGING = 'second-returns-charging',
  TESTING_A_A_A_EXP = 'testing_a_a_a_exp',
  A_A_TEST_STATSIG_SANITY = 'a_a_test_statsig_sanity',
  TRACKING_PAGE_CONTACT_US = 'tracking-page-contact-us',
  EDD = 'edd',
  CART_SPACING_CLEANUP = 'cart__spacing-cleanup__mweb_all',
  EXCHANGE_FOR_ANYTHING = 'exchange-for-anything',
  EXCHANGE_FOR_ANYTHING_V2 = 'exchange-for-anything-v2',
  PROGRESSIVE_DISCLOSURE = 'progressive-disclosure',
  PROGRESSIVE_DISCLOSURE_V2 = 'progressive-disclosure-v2',
  RETURNS_MINI_PDP = 'returns_mini_pdp',
  NEW_CART_RECOMMENDATIONS = 'new-cart-recommendations',
  RETURN_LESS_REFUND = 'return-less-refund',
  PERSONALISED_EXPLORE_EVERYTHING = 'personalized-explore-everything',
  FEATURE_SECTION_2_DESIGN = 'feature-section-2-design',
  CLP_PERSONALISATION = 'clp_personalisation',
  PDP_TAG_VISIBILITY = 'pdp-tag-visibility',
  ENABLE_NEW_IDME_DISCOUNT_API = 'enable-new-idme-discount-api',
  OOS_CART = 'out-of-stock-cart',
  PERSONALIZED_BESTSELLER = 'personalized_best_seller_v3',
  REFUND_OPTIONS_REDESIGN = 'refund_options_redesign',
  CHECKOUT_REDESIGN = 'checkout-redesign',
  CHECKOUT_LOADER_REDESIGN = 'checkout-loader-redesign',
  ATC_CONFIRMATION_AND_RECOMMENDATION_MWEB = 'atc_confirmationandrecommendation_mweb',
  A_A_LOCALISATION_ALL = 'a_a_localisation_all',
  A_A_LOCALISATION_CA_ONLY = 'a_a_localisation_ca_only',
  A_A_LOCALISATION_US_ONLY = 'a_a_localisation_usa_only',
  ENABLE_USA_LOCALISATION = 'enable_localisation_usa',
  ENABLE_LOCALISATION_DROPDOWN = 'enable-localisation-dropdown',
  CHAT_PROVIDER_DEFAULT = 'chat-provider-default',
  MINI_PDP_EXPERIMENT = 'mini-pdp-web',
  SIGN_IN_WITH_CODE = 'login-via-code',
  CART_EDD = 'cart_edd',
  EXPERIMENT_HOMEPAGE_WEB = 'experiment_homepage_web',
  EXPERIMENT_HOMEPAGE_MOBILE = 'experiment_homepage_mobile',
  EXPERIMENT_HOMEPAGE_DESKTOP = 'experiment_homepage_desktop',
  VELOU_FILTERS = 'velou_filters',
  PDP_MODEL_SIZE_TAG_VISIBILITY = 'pdp-model-size-tag-visibility',
  BEST_SELLING_COLORS_ORDERING = 'best-selling-colors-ordering',
  USE_ULTRA_LITE = 'use-ultra-lite',
  CART_SAVINGS_PRESENTATION = 'cart-savings-presentation',
  PDP_APPLE_PAY_CA = 'pdp__apple_pay__mweb_ca',
  RECURRING_ITEM_SUBSCRIPTIONS_ENABLED = 'recurring-item-subscriptions-enabled',
  CLP_PL_USER_ROLLOUT_CONTROL = 'clp-pl-user-rollout-control',
  HOME_PL_USER_ROLLOUT_CONTROL = 'home-pl-user-rollout-control',
  HIDE_KLARNA_EXP = 'hide-klarna-pdp',
  PDP_SIZE_CHART_V2 = 'pdp-size-chart-v2-web',
  CLP_RANKING_WEB = 'clp-ranking-web',
  CLP_DYNAMIC_PAGES_RANKING_WEB = 'clp-dynamic-pages-ranking-web',
  PDP_NAVIGATION_NEW = 'pdp-navigation-new',
  CART_REFACTOR = 'cart-refactor',
  ATC_VS_ATB_COPY_WEB = 'atc-vs-atb-copy-web',
  BIS_WAITLIST_SMS_WEB_MWEB = 'bis_waitlist_sms-web-mweb',
  EMAIL_WRITE_REVIEW_CTA_REDIRECTION = 'email-write-review-cta-redirection',
  PDP_VIDEO_FORMAT = 'web-pdp-video-format',
  PDP__PRODUCT_IMAGES_IMAGES_EXPERIMENTATION__ALL_US_CA = 'pdp__product-images_images-experimentation__all_us-ca',
  PDP_BREADCRUMB = 'pdp__breadcrumb',
  PDP_PL_USER_ROLLOUT_CONTROL = 'pdp__pl-rollout__web-mweb_us-ca',
  RETURN_EXCHANGE_FOR_ANYTHING_PRODUCT_LIST = 'return__exchange_for_anything_product_list__all_all',
  CART_UNDER_30_DEFAULT = 'cart__under-30-default__web-mweb_us-ca',
  EFA_CHECKOUT_REDIRECT = 'efa_checkout_redirection',
  EFA_PHASE1 = 'efaphase1',
  RETURN_MULTI_EFA = 'return__multiefa__all_all',
  CHECKOUT_SHARING_PII_PROTECTION = 'checkout-sharing-pii-protection',
  PDP_REVIEWS_SORT_WEB = 'pdp_reviews_sort_web',
  SWIPEABLE_PRODUCT_CARD_CLP = 'swipeable-product-card-clp',
  PDP_STYLITICS_EXPERIENCE = 'pdp__stylitics_experience',
  RAMP_DS_ROLLOUT = 'ramp_ds-rollout__web',
  PDP_MTE_RERANKER = 'pdp_mte_reranker_web',
  RAMP_SVD_ROLLOUT = 'ramp_svd-rollout-web',
  MY_ORDERS_REVIEWS_SUBMISSION_FLOW_WEB = 'my_orders_reviews_submission_flow_web',
  MY_ORDERS_REVIEWS_SUBMISSION_FLOW_APP = 'my_orders_reviews_submission_flow_app',
  PARTYTOWN_FB_OFFLOAD = 'all__fb-pixel_partytown-offload__web',
}

export enum STATSIG_EXPERIMENTS_BUCKETS {
  CONTROL = 'control',
  SHOW = 'show',
  GROUP_A = 'groupA',
  GROUP_B = 'groupB',
  GROUP_C = 'groupC',
  GROUP_D = 'groupD',
  TEST = 'test',
  TEST_A = 'testA',
  CONTROL_CAP = 'Control',
  SHOWA_CAP = 'ShowA',
  SHOWB_CAP = 'ShowB',
  TEST_CAP = 'Test',
  DYNAMIC_RANKING_ENABLED = 'dynamic_ranking_enabled',
  TREATMENT = 'treatment',
}
export const STATSIG_NO_FALLBACK_EXPERIMENTS = new Set<STATSIG_EXPERIMENTS>([
  STATSIG_EXPERIMENTS.PERSONALIZED_BESTSELLER,
])

export const STATSIG_DEFAULT_CONTROL_SHOW_SETUP = {
  defaultBucket: STATSIG_EXPERIMENTS_BUCKETS.CONTROL,
  buckets: {
    control: STATSIG_EXPERIMENTS_BUCKETS.CONTROL,
    show: STATSIG_EXPERIMENTS_BUCKETS.SHOW,
  },
}

export const STATSIG_EXPERIMENTS_CONFIG: Record<STATSIG_EXPERIMENTS, IStatsigExperiment> = {
  [STATSIG_EXPERIMENTS.EXCHANGE_FOR_ANYTHING]: {
    experimentName: 'exchange-for-anything',
    buckets: {
      show: 'Show',
      control: 'Control',
    },
    defaultBucket: 'Control',
    defaultB2BBucket: 'Show', // 100% conclusion with show behavior
  },
  [STATSIG_EXPERIMENTS.EXCHANGE_FOR_ANYTHING_V2]: {
    experimentName: 'exchange-for-anything-v2',
    buckets: {
      show: 'Show',
      control: 'Control',
    },
    defaultBucket: 'Control',
    defaultB2BBucket: 'Show', // 100% conclusion with show behavior
  },
  [STATSIG_EXPERIMENTS.PROGRESSIVE_DISCLOSURE]: {
    experimentName: 'progressive-disclosure',
    defaultBucket: 'Control',
    buckets: {
      control: 'Control',
      testA: 'TestA',
      testB: 'TestB',
    },
  },
  [STATSIG_EXPERIMENTS.PROGRESSIVE_DISCLOSURE_V2]: {
    experimentName: 'progressive-disclosure-v2',
    defaultBucket: 'Control',
    buckets: {
      control: 'Control',
      testA: 'TestA',
      testB: 'TestB',
    },
  },
  [STATSIG_EXPERIMENTS.RETURNS_MINI_PDP]: {
    experimentName: 'returns_mini_pdp',
    defaultBucket: 'Control',
    buckets: {
      control: 'Control',
      test: 'Test',
    },
  },
  [STATSIG_EXPERIMENTS.NEW_CART_RECOMMENDATIONS]: {
    experimentName: 'new-cart-recommendations',
    defaultBucket: 'Control',
    buckets: {
      test: 'Test',
      control: 'Control',
    },
  },
  [STATSIG_EXPERIMENTS.RETURN_LESS_REFUND]: {
    experimentName: 'return-less-refund',
    defaultBucket: 'Control',
    buckets: {
      show: 'Test',
      control: 'Control',
    },
  },
  [STATSIG_EXPERIMENTS.BANNER_A_CLP_A_V_A_EXPERIMENT]: {
    experimentName: 'banner-a-clp-a-v-clp-a',
    defaultBucket: 'Control',
  },
  [STATSIG_EXPERIMENTS.SECOND_RETURNS_CHARGING]: {
    experimentName: 'second-returns-charging',
    defaultBucket: 'Control',
  },
  [STATSIG_EXPERIMENTS.EXPRESS_CHECKOUT_IN_CART]: {
    experimentName: 'express-checkout-in-cart',
    defaultBucket: 'control',
    buckets: {
      testA: 'testA',
      testB: 'testB',
      control: 'control',
    },
  },

  [STATSIG_EXPERIMENTS.PDP_TAG_VISIBILITY]: {
    experimentName: 'pdp-tag-visibility',
    buckets: {
      control: 'control',
      groupA: 'groupA',
    },
    defaultBucket: 'control',
  },
  [STATSIG_EXPERIMENTS.ENABLE_NEW_IDME_DISCOUNT_API]: {
    experimentName: 'enable-new-idme-discount-api',
    buckets: {
      Control: 'Control',
      Show: 'Show',
    },
    defaultBucket: 'Control',
  },
  [STATSIG_EXPERIMENTS.EDD]: {
    experimentName: 'edd',
    defaultBucket: 'control',
    buckets: {
      control: 'control',
      groupA: 'groupA',
      groupB: 'groupB',
    },
  },

  [STATSIG_EXPERIMENTS.CART_SPACING_CLEANUP]: {
    experimentName: 'cart__spacing-cleanup__mweb_all',
    defaultBucket: STATSIG_EXPERIMENTS_BUCKETS.CONTROL,
    buckets: {
      control: STATSIG_EXPERIMENTS_BUCKETS.CONTROL,
      show: STATSIG_EXPERIMENTS_BUCKETS.SHOW,
    },
  },

  [STATSIG_EXPERIMENTS.ATC_CONFIRMATION_AND_RECOMMENDATION_MWEB]: {
    experimentName: STATSIG_EXPERIMENTS.ATC_CONFIRMATION_AND_RECOMMENDATION_MWEB,
    defaultBucket: 'Control',
    buckets: {
      Control: STATSIG_EXPERIMENTS_BUCKETS.CONTROL_CAP,
      ShowA: STATSIG_EXPERIMENTS_BUCKETS.SHOWA_CAP,
      ShowB: STATSIG_EXPERIMENTS_BUCKETS.SHOWB_CAP,
    },
  },
  [STATSIG_EXPERIMENTS.PERSONALISED_EXPLORE_EVERYTHING]: {
    experimentName: 'personalized-explore-everything',
    defaultBucket: 'control',
    buckets: {
      control: 'control',
      show: 'show',
    },
  },
  [STATSIG_EXPERIMENTS.FEATURE_SECTION_2_DESIGN]: {
    experimentName: 'feature-section-2-design',
    defaultBucket: 'control',
    buckets: {
      control: 'control',
      groupA: 'groupA',
      groupB: 'groupB',
    },
    defaultB2BBucket: 'groupA',
  },
  [STATSIG_EXPERIMENTS.TRACKING_PAGE_CONTACT_US]: {
    experimentName: 'tracking-page-contact-us',
    defaultBucket: 'Control',
    buckets: {
      Control: 'Control',
      Experiment: 'Experiment',
    },
  },
  [STATSIG_EXPERIMENTS.CLP_PERSONALISATION]: {
    experimentName: 'clp_personalisation',
    defaultBucket: 'control',
    buckets: {
      control: 'control',
      show: 'show',
    },
  },
  [STATSIG_EXPERIMENTS.PERSONALIZED_BESTSELLER]: {
    experimentName: 'personalized_best_seller_v3',
    defaultBucket: 'control',
    buckets: {
      control: 'control',
      show: 'show',
    },
  },
  [STATSIG_EXPERIMENTS.OOS_CART]: {
    experimentName: 'out-of-stock-cart',
    defaultBucket: 'control',
    buckets: {
      control: 'Control',
      show: 'Show',
    },
    defaultB2BBucket: 'Show',
  },
  [STATSIG_EXPERIMENTS.REFUND_OPTIONS_REDESIGN]: {
    experimentName: 'refund_options_redesign',
    defaultBucket: STATSIG_EXPERIMENTS_BUCKETS.CONTROL,
    buckets: {
      control: 'Control',
      show: 'Show',
    },
    defaultB2BBucket: 'Show', // 100% conclusion with show behavior
  },
  [STATSIG_EXPERIMENTS.CHECKOUT_REDESIGN]: {
    experimentName: 'checkout-redesign',
    defaultBucket: STATSIG_EXPERIMENTS_BUCKETS.CONTROL,
    buckets: {
      Control: 'Control',
      Show: 'Show',
    },
  },
  [STATSIG_EXPERIMENTS.CHECKOUT_LOADER_REDESIGN]: {
    experimentName: 'checkout-loader-redesign',
    ...STATSIG_DEFAULT_CONTROL_SHOW_SETUP,
  },

  [STATSIG_EXPERIMENTS.CART_UNDER_30_DEFAULT]: {
    experimentName: STATSIG_EXPERIMENTS.CART_UNDER_30_DEFAULT,
    defaultBucket: STATSIG_EXPERIMENTS_BUCKETS.CONTROL,
    buckets: {
      Control: 'Control',
      Show: 'Show',
    },
  },
  [STATSIG_EXPERIMENTS.EFA_CHECKOUT_REDIRECT]: {
    experimentName: STATSIG_EXPERIMENTS.EFA_CHECKOUT_REDIRECT,
    ...STATSIG_DEFAULT_CONTROL_SHOW_SETUP,
  },
  [STATSIG_EXPERIMENTS.CHECKOUT_SHARING_PII_PROTECTION]: {
    experimentName: 'checkout-sharing-pii-protection',
    defaultBucket: STATSIG_EXPERIMENTS_BUCKETS.CONTROL,
    buckets: {
      Control: 'Control',
      Show: 'Show',
    },
  },
  [STATSIG_EXPERIMENTS.A_A_LOCALISATION_ALL]: {
    experimentName: 'a_a_localisation_all',
    ...STATSIG_DEFAULT_CONTROL_SHOW_SETUP,
  },
  [STATSIG_EXPERIMENTS.A_A_LOCALISATION_CA_ONLY]: {
    experimentName: 'a_a_localisation_ca_only',
    ...STATSIG_DEFAULT_CONTROL_SHOW_SETUP,
  },
  [STATSIG_EXPERIMENTS.A_A_LOCALISATION_US_ONLY]: {
    experimentName: 'a_a_localisation_usa_only',
    ...STATSIG_DEFAULT_CONTROL_SHOW_SETUP,
  },
  [STATSIG_EXPERIMENTS.ENABLE_USA_LOCALISATION]: {
    experimentName: 'enable_localisation_usa',
    ...STATSIG_DEFAULT_CONTROL_SHOW_SETUP,
  },
  [STATSIG_EXPERIMENTS.ENABLE_LOCALISATION_DROPDOWN]: {
    experimentName: 'enable-localisation-dropdown',
    ...STATSIG_DEFAULT_CONTROL_SHOW_SETUP,
  },
  [STATSIG_EXPERIMENTS.CHAT_PROVIDER_DEFAULT]: {
    experimentName: 'chat-provider-default',
    defaultBucket: STATSIG_EXPERIMENTS_BUCKETS.CONTROL,
    buckets: {
      control: STATSIG_EXPERIMENTS_BUCKETS.CONTROL,
      show: STATSIG_EXPERIMENTS_BUCKETS.SHOW,
    },
  },
  [STATSIG_EXPERIMENTS.MINI_PDP_EXPERIMENT]: {
    experimentName: STATSIG_EXPERIMENTS.MINI_PDP_EXPERIMENT,
    defaultBucket: STATSIG_EXPERIMENTS_BUCKETS.CONTROL,
    buckets: {
      control: STATSIG_EXPERIMENTS_BUCKETS.CONTROL,
      show: STATSIG_EXPERIMENTS_BUCKETS.SHOW,
    },
  },
  [STATSIG_EXPERIMENTS.SIGN_IN_WITH_CODE]: {
    experimentName: 'login-via-code',
    defaultBucket: STATSIG_EXPERIMENTS_BUCKETS.SHOW,
    buckets: {
      control: STATSIG_EXPERIMENTS_BUCKETS.CONTROL,
      show: STATSIG_EXPERIMENTS_BUCKETS.SHOW,
    },
  },
  [STATSIG_EXPERIMENTS.CART_EDD]: {
    experimentName: 'cart_edd',
    defaultBucket: 'Control',
    buckets: {
      control: 'Control',
      show: 'Show',
    },
  },
  [STATSIG_EXPERIMENTS.EXPERIMENT_HOMEPAGE_WEB]: {
    experimentName: 'experiment_homepage_web',
    defaultBucket: 'Control',
    buckets: {
      control: 'control',
      testA: 'testA',
      testB: 'testB',
      testC: 'testC',
    },
  },
  [STATSIG_EXPERIMENTS.EXPERIMENT_HOMEPAGE_MOBILE]: {
    experimentName: 'experiment_homepage_mobile',
    defaultBucket: 'Control',
    buckets: {
      control: 'Control',
      testA: 'testA',
      testB: 'testB',
      testC: 'testC',
    },
  },
  [STATSIG_EXPERIMENTS.EXPERIMENT_HOMEPAGE_DESKTOP]: {
    experimentName: 'experiment_homepage_desktop',
    defaultBucket: 'Control',
    buckets: {
      control: 'Control',
      testA: 'testA',
      testB: 'testB',
      testC: 'testC',
    },
  },
  [STATSIG_EXPERIMENTS.VELOU_FILTERS]: {
    experimentName: 'velou_filters',
    defaultBucket: STATSIG_EXPERIMENTS_BUCKETS.CONTROL,
    buckets: {
      control: STATSIG_EXPERIMENTS_BUCKETS.CONTROL,
      test: STATSIG_EXPERIMENTS_BUCKETS.TEST,
    },
  },
  [STATSIG_EXPERIMENTS.PDP_MODEL_SIZE_TAG_VISIBILITY]: {
    experimentName: 'pdp-model-size-tag-visibility',
    ...STATSIG_DEFAULT_CONTROL_SHOW_SETUP,
  },
  [STATSIG_EXPERIMENTS.BEST_SELLING_COLORS_ORDERING]: {
    experimentName: 'best-selling-colors-ordering',
    defaultBucket: STATSIG_EXPERIMENTS_BUCKETS.CONTROL,
    buckets: {
      control: STATSIG_EXPERIMENTS_BUCKETS.CONTROL,
      show: STATSIG_EXPERIMENTS_BUCKETS.SHOW,
    },
  },
  [STATSIG_EXPERIMENTS.USE_ULTRA_LITE]: {
    experimentName: 'use-ultra-lite',
    defaultBucket: STATSIG_EXPERIMENTS_BUCKETS.CONTROL,
    buckets: {
      control: STATSIG_EXPERIMENTS_BUCKETS.CONTROL,
      show: STATSIG_EXPERIMENTS_BUCKETS.SHOW,
    },
  },
  [STATSIG_EXPERIMENTS.PDP_APPLE_PAY_CA]: {
    experimentName: STATSIG_EXPERIMENTS.PDP_APPLE_PAY_CA,
    defaultBucket: 'Control',
    buckets: {
      control: 'Control',
      test: 'Test',
    },
  },
  [STATSIG_EXPERIMENTS.CART_SAVINGS_PRESENTATION]: {
    experimentName: 'cart-savings-presentation',
    defaultBucket: STATSIG_EXPERIMENTS_BUCKETS.CONTROL,
    buckets: {
      control: STATSIG_EXPERIMENTS_BUCKETS.CONTROL,
      test: STATSIG_EXPERIMENTS_BUCKETS.TEST,
    },
  },
  [STATSIG_EXPERIMENTS.TESTING_A_A_A_EXP]: {
    experimentName: STATSIG_EXPERIMENTS.TESTING_A_A_A_EXP,
    ...STATSIG_DEFAULT_CONTROL_SHOW_SETUP,
  },
  [STATSIG_EXPERIMENTS.A_A_TEST_STATSIG_SANITY]: {
    experimentName: STATSIG_EXPERIMENTS.A_A_TEST_STATSIG_SANITY,
    ...STATSIG_DEFAULT_CONTROL_SHOW_SETUP,
  },
  [STATSIG_EXPERIMENTS.CART_REFACTOR]: {
    experimentName: 'cart-refactor',
    defaultBucket: STATSIG_EXPERIMENTS_BUCKETS.CONTROL,
    buckets: {
      control: STATSIG_EXPERIMENTS_BUCKETS.CONTROL,
      show: STATSIG_EXPERIMENTS_BUCKETS.SHOW,
    },
  },
  [STATSIG_EXPERIMENTS.RECURRING_ITEM_SUBSCRIPTIONS_ENABLED]: {
    experimentName: STATSIG_EXPERIMENTS.RECURRING_ITEM_SUBSCRIPTIONS_ENABLED,
    defaultBucket: STATSIG_EXPERIMENTS_BUCKETS.CONTROL,
    buckets: {
      control: STATSIG_EXPERIMENTS_BUCKETS.CONTROL,
      show: STATSIG_EXPERIMENTS_BUCKETS.SHOW,
    },
  },
  [STATSIG_EXPERIMENTS.MWEB_APP_BANNER]: {
    experimentName: STATSIG_EXPERIMENTS.MWEB_APP_BANNER,
    defaultBucket: STATSIG_EXPERIMENTS_BUCKETS.CONTROL,
    buckets: {
      control: STATSIG_EXPERIMENTS_BUCKETS.CONTROL,
      groupA: STATSIG_EXPERIMENTS_BUCKETS.GROUP_A,
      groupB: STATSIG_EXPERIMENTS_BUCKETS.GROUP_B,
    },
  },
  [STATSIG_EXPERIMENTS.CLP_PL_USER_ROLLOUT_CONTROL]: {
    experimentName: STATSIG_EXPERIMENTS.CLP_PL_USER_ROLLOUT_CONTROL,
    defaultBucket: STATSIG_EXPERIMENTS_BUCKETS.CONTROL,
    buckets: {
      control: STATSIG_EXPERIMENTS_BUCKETS.CONTROL,
      test: STATSIG_EXPERIMENTS_BUCKETS.TEST,
    },
  },
  [STATSIG_EXPERIMENTS.HOME_PL_USER_ROLLOUT_CONTROL]: {
    experimentName: STATSIG_EXPERIMENTS.HOME_PL_USER_ROLLOUT_CONTROL,
    defaultBucket: STATSIG_EXPERIMENTS_BUCKETS.CONTROL,
    buckets: {
      control: STATSIG_EXPERIMENTS_BUCKETS.CONTROL,
      test: STATSIG_EXPERIMENTS_BUCKETS.TEST,
    },
  },
  [STATSIG_EXPERIMENTS.HIDE_KLARNA_EXP]: {
    experimentName: 'hide-klarna-pdp',
    defaultBucket: STATSIG_EXPERIMENTS_BUCKETS.CONTROL,
    buckets: {
      control: STATSIG_EXPERIMENTS_BUCKETS.CONTROL,
      show: STATSIG_EXPERIMENTS_BUCKETS.SHOW,
    },
  },
  [STATSIG_EXPERIMENTS.PDP_SIZE_CHART_V2]: {
    experimentName: 'pdp-size-chart-v2-web',
    defaultBucket: STATSIG_EXPERIMENTS_BUCKETS.CONTROL,
    buckets: {
      control: STATSIG_EXPERIMENTS_BUCKETS.CONTROL,
      show: STATSIG_EXPERIMENTS_BUCKETS.SHOW,
    },
  },
  [STATSIG_EXPERIMENTS.PDP_NAVIGATION_NEW]: {
    experimentName: 'pdp-navigation-new',
    ...STATSIG_DEFAULT_CONTROL_SHOW_SETUP,
  },
  [STATSIG_EXPERIMENTS.CLP_RANKING_WEB]: {
    experimentName: 'clp-ranking-web',
    defaultBucket: 'clp_v2_7',
    buckets: {
      control: 'control',
      clp_v2_7: 'clp_v2_7',
    },
  },
  [STATSIG_EXPERIMENTS.CLP_DYNAMIC_PAGES_RANKING_WEB]: {
    experimentName: 'clp-dynamic-pages-ranking-web',
    defaultBucket: STATSIG_EXPERIMENTS_BUCKETS.CONTROL,
    buckets: {
      control: STATSIG_EXPERIMENTS_BUCKETS.CONTROL,
      dynamic_ranking_enabled: STATSIG_EXPERIMENTS_BUCKETS.DYNAMIC_RANKING_ENABLED,
    },
  },
  [STATSIG_EXPERIMENTS.ATC_VS_ATB_COPY_WEB]: {
    experimentName: STATSIG_EXPERIMENTS.ATC_VS_ATB_COPY_WEB,
    defaultBucket: STATSIG_EXPERIMENTS_BUCKETS.CONTROL,
    buckets: {
      control: STATSIG_EXPERIMENTS_BUCKETS.CONTROL,
      show: STATSIG_EXPERIMENTS_BUCKETS.SHOW,
    },
  },
  [STATSIG_EXPERIMENTS.BIS_WAITLIST_SMS_WEB_MWEB]: {
    experimentName: STATSIG_EXPERIMENTS.BIS_WAITLIST_SMS_WEB_MWEB,
    defaultBucket: STATSIG_EXPERIMENTS_BUCKETS.CONTROL,
    buckets: {
      control: STATSIG_EXPERIMENTS_BUCKETS.CONTROL,
      show: STATSIG_EXPERIMENTS_BUCKETS.SHOW,
    },
  },
  [STATSIG_EXPERIMENTS.EMAIL_WRITE_REVIEW_CTA_REDIRECTION]: {
    experimentName: 'email-write-review-cta-redirection',
    defaultBucket: STATSIG_EXPERIMENTS_BUCKETS.CONTROL,
    buckets: {
      control: STATSIG_EXPERIMENTS_BUCKETS.CONTROL,
      show: STATSIG_EXPERIMENTS_BUCKETS.SHOW,
    },
  },
  [STATSIG_EXPERIMENTS.PDP_VIDEO_FORMAT]: {
    experimentName: 'web-pdp-video-format',
    defaultBucket: STATSIG_EXPERIMENTS_BUCKETS.CONTROL,
    buckets: {
      control: STATSIG_EXPERIMENTS_BUCKETS.CONTROL,
      groupA: STATSIG_EXPERIMENTS_BUCKETS.GROUP_A,
      groupB: STATSIG_EXPERIMENTS_BUCKETS.GROUP_B,
    },
  },
  [STATSIG_EXPERIMENTS.PDP__PRODUCT_IMAGES_IMAGES_EXPERIMENTATION__ALL_US_CA]: {
    experimentName: STATSIG_EXPERIMENTS.PDP__PRODUCT_IMAGES_IMAGES_EXPERIMENTATION__ALL_US_CA,
    defaultBucket: STATSIG_EXPERIMENTS_BUCKETS.CONTROL,
    buckets: {
      control: STATSIG_EXPERIMENTS_BUCKETS.CONTROL,
      groupA: STATSIG_EXPERIMENTS_BUCKETS.GROUP_A,
      groupB: STATSIG_EXPERIMENTS_BUCKETS.GROUP_B,
    },
  },
  [STATSIG_EXPERIMENTS.PDP_BREADCRUMB]: {
    experimentName: STATSIG_EXPERIMENTS.PDP_BREADCRUMB,
    defaultBucket: STATSIG_EXPERIMENTS_BUCKETS.CONTROL,
    buckets: {
      control: STATSIG_EXPERIMENTS_BUCKETS.CONTROL,
      groupA: STATSIG_EXPERIMENTS_BUCKETS.GROUP_A,
      groupB: STATSIG_EXPERIMENTS_BUCKETS.GROUP_B,
      groupC: STATSIG_EXPERIMENTS_BUCKETS.GROUP_C,
    },
  },
  [STATSIG_EXPERIMENTS.PDP_PL_USER_ROLLOUT_CONTROL]: {
    experimentName: STATSIG_EXPERIMENTS.PDP_PL_USER_ROLLOUT_CONTROL,
    defaultBucket: STATSIG_EXPERIMENTS_BUCKETS.CONTROL,
    buckets: {
      control: STATSIG_EXPERIMENTS_BUCKETS.CONTROL,
      test: STATSIG_EXPERIMENTS_BUCKETS.TEST,
    },
  },
  [STATSIG_EXPERIMENTS.RETURN_EXCHANGE_FOR_ANYTHING_PRODUCT_LIST]: {
    experimentName: 'return__exchange_for_anything_product_list__all_all',
    defaultBucket: 'Control',
    buckets: {
      control: 'Control',
      efa_sp: 'efa_sp',
      efa_spc: 'efa_spc',
    },
  },
  [STATSIG_EXPERIMENTS.PDP_REVIEWS_SORT_WEB]: {
    experimentName: 'pdp_reviews_sort_web',
    ...STATSIG_DEFAULT_CONTROL_SHOW_SETUP,
  },
  [STATSIG_EXPERIMENTS.SWIPEABLE_PRODUCT_CARD_CLP]: {
    experimentName: 'swipeable-product-card-clp',
    ...STATSIG_DEFAULT_CONTROL_SHOW_SETUP,
  },
  [STATSIG_EXPERIMENTS.PDP_STYLITICS_EXPERIENCE]: {
    experimentName: 'pdp__stylitics_experience',
    defaultBucket: STATSIG_EXPERIMENTS_BUCKETS.CONTROL,
    buckets: {
      control: STATSIG_EXPERIMENTS_BUCKETS.CONTROL,
      show: STATSIG_EXPERIMENTS_BUCKETS.SHOW,
    },
  },
  [STATSIG_EXPERIMENTS.RAMP_DS_ROLLOUT]: {
    experimentName: STATSIG_EXPERIMENTS.RAMP_DS_ROLLOUT,
    defaultBucket: STATSIG_EXPERIMENTS_BUCKETS.CONTROL,
    buckets: {
      control: STATSIG_EXPERIMENTS_BUCKETS.CONTROL,
      test: STATSIG_EXPERIMENTS_BUCKETS.TEST,
    },
  },
  [STATSIG_EXPERIMENTS.PDP_MTE_RERANKER]: {
    experimentName: 'pdp_mte_reranker_web',
    defaultBucket: 'Control',
    buckets: {
      control: 'Control',
      test: 'Test',
    },
  },
  [STATSIG_EXPERIMENTS.RAMP_SVD_ROLLOUT]: {
    experimentName: STATSIG_EXPERIMENTS.RAMP_SVD_ROLLOUT,
    ...STATSIG_DEFAULT_CONTROL_SHOW_SETUP,
  },
  [STATSIG_EXPERIMENTS.EFA_PHASE1]: {
    experimentName: STATSIG_EXPERIMENTS.EFA_PHASE1,
    defaultBucket: STATSIG_EXPERIMENTS_BUCKETS.CONTROL,
    buckets: {
      control: STATSIG_EXPERIMENTS_BUCKETS.CONTROL,
      show: STATSIG_EXPERIMENTS_BUCKETS.SHOW,
    },
  },
  // EFA Phase 2: show "Exchange for Anything" on multi-item orders. Control (default) is the
  // holdout; the "show" bucket enables the phase-2 experience in post-order-web / fe-common.
  [STATSIG_EXPERIMENTS.RETURN_MULTI_EFA]: {
    experimentName: STATSIG_EXPERIMENTS.RETURN_MULTI_EFA,
    defaultBucket: STATSIG_EXPERIMENTS_BUCKETS.CONTROL,
    buckets: {
      control: STATSIG_EXPERIMENTS_BUCKETS.CONTROL,
      show: STATSIG_EXPERIMENTS_BUCKETS.TEST_CAP,
    },
  },
  // My Orders revamped review-submission flow (STRFRNT-12653 M2). Test → new progressive flow,
  // Control → existing legacy review modal. Web/mWeb vs app-webview are separate experiments.
  [STATSIG_EXPERIMENTS.MY_ORDERS_REVIEWS_SUBMISSION_FLOW_WEB]: {
    experimentName: STATSIG_EXPERIMENTS.MY_ORDERS_REVIEWS_SUBMISSION_FLOW_WEB,
    defaultBucket: STATSIG_EXPERIMENTS_BUCKETS.CONTROL_CAP,
    buckets: {
      control: STATSIG_EXPERIMENTS_BUCKETS.CONTROL_CAP,
      test: STATSIG_EXPERIMENTS_BUCKETS.TEST_CAP,
    },
  },
  [STATSIG_EXPERIMENTS.MY_ORDERS_REVIEWS_SUBMISSION_FLOW_APP]: {
    experimentName: STATSIG_EXPERIMENTS.MY_ORDERS_REVIEWS_SUBMISSION_FLOW_APP,
    defaultBucket: STATSIG_EXPERIMENTS_BUCKETS.CONTROL_CAP,
    buckets: {
      control: STATSIG_EXPERIMENTS_BUCKETS.CONTROL_CAP,
      test: STATSIG_EXPERIMENTS_BUCKETS.TEST_CAP,
    },
  },
  // User-aware experiment gating the Partytown fbevents offload (Control vs Test). Group names are the
  // console's capitalised `Control` / `Test`, verified against the Statsig experiment definition and
  // matching the older experiments' convention. The SSR resolver compares `getGroupName()` verbatim, so
  // these spellings must stay in lockstep with the console — a drift silently pins everyone to Control.
  // Ships at 0% allocation until Meta event parity + the CloudFront /fb-proxy behaviour are in place.
  [STATSIG_EXPERIMENTS.PARTYTOWN_FB_OFFLOAD]: {
    experimentName: STATSIG_EXPERIMENTS.PARTYTOWN_FB_OFFLOAD,
    defaultBucket: STATSIG_EXPERIMENTS_BUCKETS.CONTROL_CAP,
    buckets: {
      control: STATSIG_EXPERIMENTS_BUCKETS.CONTROL_CAP,
      test: STATSIG_EXPERIMENTS_BUCKETS.TEST_CAP,
    },
  },
}
